export default __webpack_public_path__ + "static/media/germany.70161c2e.jpg";